import { Component, computed, HostBinding, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BaasAppState } from '@lvflanders/bar';

import { BaasUnavailableLayout } from '../../layout/baas-unavailable-layout/baas-unavailable-layout';

const DEFAULT_TITLE = 'Pagina onbeschikbaar';
const DEFAULT_CONTENT = 'De pagina is onbeschikbaar';

@Component({
    selector: 'baas-blocking-melding',
    templateUrl: './baas-blocking-melding.html',
    imports: [BaasUnavailableLayout]
})
export class BaasBlockingMelding {
    readonly #state = inject(BaasAppState);
    readonly #domSanitizer = inject(DomSanitizer);
    readonly title = input(DEFAULT_TITLE);
    readonly content = input<string>(DEFAULT_CONTENT);
    readonly scaling = input<'none' | 'medium'>(undefined);
    readonly showGlobalHeaderFooter = input(false);

    protected readonly sanitizedContent = computed(() => this.#domSanitizer.bypassSecurityTrustHtml(this.content()));

    protected homeUrl = this.#state.config.homeUrl as string;

    @HostBinding('class.scaled-medium')
    protected get isMediumScaled() {
        return this.scaling() === 'medium';
    }
}
